import { useState, useEffect } from "react";
import useAppData from "../../hooks/useAppData";
import { useModal } from "../../context/ModalContext";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const words = ["accuracy", "precision", "reliability"];

export default function HeroBanner() {
	const { settings } = useAppData();
	const { openQuote } = useModal();
	const [wordIndex, setWordIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setWordIndex((prev) => (prev + 1) % words.length);
		}, 2000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div
			className={`
				w-full h-screen flex justify-center object-contain relative
				
			`}
		>
			<video
				className="absolute -z-10 h-full w-full object-cover"
				autoPlay
				muted
				loop
				playsInline
				preload="none"
			>
				<source src="/assets/videos/dubai.mp4" type="video/mp4" />
				Your browser does not support the video tag.
			</video>
			<div className="absolute inset-0 bg-black/70 z-0"></div>

			<div
				className={`
				w-full max-w-7xl mx-auto flex flex-col justify-center items-center z-20 mt-25 px-5
				lg:justify-between lg:flex-row lg:mt-0 lg:px-10
				`}
			>
				<div className="flex flex-col justify-center gap-9 text-white text-lg">
					{/* left content */}
					<h1 className="md:text-5xl text-2xl md:leading-15 leading-10 Ethnocentric">
						Delivering speed
						<br />
						with{" "}
						<span className="text-brand-500 inline-block">
							<AnimatePresence mode="wait">
								<motion.span
									key={words[wordIndex]}
									initial={{ opacity: 0, y: 10 }}
									animate={{ opacity: 1, y: 0 }}
									exit={{ opacity: 0, y: -10 }}
									transition={{ duration: 0.4 }}
								>
									{words[wordIndex]}
								</motion.span>
							</AnimatePresence>
						</span>
					</h1>
					<p className="md:text-2xl md:leading-8 text-lg leading-6">
						Seamless cargo solution designed for speed, safety and global reach.
						<br />
						your delivery, our priority across borders, across industries.
					</p>
					<div className="flex lg:flex-row flex-col gap-6 text-white md:text-lg text-md text-center">
						<Link
							className="border-brand-500 border-2 py-3 px-4 ha:bg-brand-500 active:bg-brand-500 transition duration-300 ease-in-out"
							to={`/services`}
						>
							Explore Our Services
						</Link>
						<Link
							className="border-brand-500 border-2 py-3 px-4 bg-brand-500 ha:bg-brand-600 ha:border-brand-600 active:bg-brand-600 active:border-brand-600 transition duration-300 ease-in-out"
							onClick={openQuote}
						>
							Calculate Shipping Cost
						</Link>
					</div>
				</div>

				<div className="flex items-center lg:mt-0 mt-8">
					<div className="flex lg:flex-col flex-row lg:gap-6 gap-10 bg-black/50 p-4 rounded-lg text-white text-lg">
						<a
							href={settings?.instagram || "https://instagram.com"}
							target="_blank"
							rel="noreferrer"
						>
							<i className="bi bi-instagram"></i>
						</a>
						<a
							href={settings?.facebook || "https://facebook.com"}
							target="_blank"
							rel="noreferrer"
						>
							<i className="bi bi-facebook"></i>
						</a>
						<a
							href={settings?.linkedin || "https://linkedin.com"}
							target="_blank"
							rel="noreferrer"
						>
							<i className="bi bi-linkedin"></i>
						</a>
						<a
							href={`tel:${settings?.phone_number || "https://linkedin.com"}`}
							target="_blank"
							rel="noreferrer"
						>
							<i className="bi bi-telephone-fill"></i>
						</a>
						<a
							href={`mailto:${settings?.email || "mailto:info@bluedartexpress.ae"}`}
							target="_blank"
							rel="noreferrer"
						>
							<i className="bi bi-envelope"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
